<template>
    <div class="rule-group">
        <div class="rule-group__relation-config">
            <v-radio-group
                :value="conditionType"
                @change="onChangeConditionType"
            >
                <v-radio
                    name="and"
                    value="and"
                >
                    满足以下全部条件
                </v-radio>
                <v-radio
                    name="or"
                    value="or"
                >
                    满足以下任一条件
                </v-radio>
            </v-radio-group>
        </div>
        <v-popconfirm
            ref="removeGroup"
            placement="bottom-end"
            status="warning"
            @confirm="onRemoveGroup"
        >
            <div style="width:208px;margin-bottom:10px;">
                删除该条件组？
            </div>
            <span slot="confirm-text">删除</span>
        </v-popconfirm>
        <v-tip
            ref="removeGroupTips"
            placement="top"
        >
            <span>删除</span>
        </v-tip>
        <div
            v-tip:removeGroupTips
            class="rule-group__remove-btn"
        >
            <v-icon
                v-popconfirm:removeGroup
                name="delete"
            />
        </div>
        <div class="rule-list">
            <template v-for="(item, index) in ruleList">
                <rule-item
                    ref="ruleitem"
                    :key="item.showData.componentName + index"
                    :value="item.showData.value"
                    :valid="item.showData.validation"
                    :component-name="item.showData.componentName"
                    :option-info="item.showData.info"
                    :rule-options="ruleOptions"
                    :preloaded-data="preloadedData[item.showData.componentName]"
                    @remove="
                        () => {
                            onRemoveItem(index);
                        }
                    "
                    @change="
                        value => {
                            onRuleChange(value, index);
                        }
                    "
                    @change-component="
                        optionConfig => {
                            onChangeComponent(optionConfig, index);
                        }
                    "
                />
            </template>
        </div>
        <div :class="{ 'rule-group__add-item': true, 'group-invalid': !valid }">
            <v-icon name="add" />
            <span>添加条件</span>
            <rule-selector
                :value="defaultComponentName"
                :rule-options="ruleOptions"
                @change-component="onAddComponent"
            />
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import RuleItem from '../rule-item';
import RuleSelector from '../rule-selector';

const req = require.context('../../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
  name: 'RuleGroup',

  components: {
    RuleItem,
    RuleSelector,
  },

  props: {
    // 下拉树定义，如果是字符串则展示一个没有下拉只有名字的面板
    ruleOptions: {
      type: [Array, String],
      default() {
        return null;
      },
    },
    value: {
      type: [Object],
      default() {
        return { ruleList: [], logic: 'or' };
      },
    },
    preloadedData: {
      type: Object,
      default() {
        return null;
      },
    },
  },

  data() {
    return {
      conditionType: this.value.logic,
      ruleList: this.value.ruleList || [],
      defaultComponentName: '',
      valid: true,
    };
  },

  computed: {},
  watch: {
    value() {
      this.setInnerData();
    },
  },
  created() {},

  methods: {
    setInnerData() {
      this.conditionType = this.value.logic;
      this.ruleList = this.value.ruleList || [];
    },
    onAddComponent(item) {
      const { ruleList } = this;
      let value;
      // 特殊处理value值
      if (item.componentName === 'CustomerStatus') {
        value = {
          statusValue: undefined,
          holderValue: undefined,
        };
      }
      if (item.componentName === 'Education') {
        value = {
          logicValue: '==',
          educationValue: [],
        };
      }
      ruleList.push({
        showData: {
          componentName: item.componentName,
          info: item,
          value,
          validation: false,
        },
      });
      this.onChange();
    },
    onRemoveItem(index) {
      this.ruleList.splice(index, 1);
      this.onChange();
    },
    onRemoveGroup() {
      this.$emit('remove');
    },
    onChangeConditionType(value) {
      this.conditionType = value;
      this.onChange();
    },
    onChange() {
      this.valid = true;
      this.$emit('change', {
        logic: this.conditionType,
        ruleList: this.ruleList,
        validation: this.validateData(),
      });
    },
    onRuleChange({ ruleData, showVal, brief, validation }, index) {
      const curRule = this.ruleList[index];
      curRule.showData.value = showVal;
      if (brief) {
        curRule.showData.brief = brief;
      }
      curRule.showData.validation = validation;
      curRule.ruleData = ruleData;
      this.onChange();
    },
    onChangeComponent(optionConfig, index) {
      const newRule = {
        showData: {
          ...optionConfig,
          value: this.getDefaultValue(optionConfig),
          brief: '',
        },
        ruleData: null,
      };
      this.$set(this.ruleList, index, newRule);
      this.onChange();
    },
    validate() {
      if (!this.ruleList || this.ruleList.length === 0) {
        this.valid = false;
        return Promise.resolve(false);
      }
      const defers = this.ruleList.map((grp, i) => this.$refs.ruleitem[i].validate());
      return Promise.all(defers).then(([...validations]) => {
        let valid = true;
        validations.forEach((itemValid) => {
          if (!itemValid) {
            valid = false;
          }
        });
        return valid;
      });
    },
    validateData() {
      let validation = true;
      this.ruleList.forEach((item) => {
        if (!item.showData.validation) {
          validation = false;
        }
      });
      return validation;
    },
    getDefaultValue(optionConfig) {
      let defaultValue;
      if (['SessionChannel', 'CustomerTag', 'Age', 'OrgSelect', 'BusinessSelect'].includes(optionConfig.componentName)) {
        defaultValue = [];
      } else if (['Gender'].includes(optionConfig.componentName)) {
        defaultValue = null;
      } else if (['Education'].includes(optionConfig.componentName)) {
        defaultValue = {
          logicValue: '==',
          educationValue: [],
        };
      } else {
        defaultValue = {};
      }
      return defaultValue;
    },
  },
};
</script>

<style lang="less">
@import './style/style.less';
</style>
